import { makeStyles, createStyles } from '@material-ui/core/styles';
import background from 'images/BG-signup.jpg';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';

export const StyledWrapper = styled(Grid)`
  padding-top: 120px;
  padding-bottom: 60px;
  background-image: url(${background});
  background-size: 2556px 1600px;
  background-position: 5% 12%;
  padding-left: 16px;
  padding-right: 16px;
`;

export const useLayoutStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      paddingTop: '120px',
      paddingBottom: '60px',
    },
    paper: {
      maxWidth: 700,
      boxShadow: '0 10px 30px 0 rgba(0,0,0,0.1)',
      borderRadius: '8px',
    },
    box: {
      minHeight: '95vh',
    },
  }),
);
